import { render, staticRenderFns, recyclableRender, components } from "./painter.vue?vue&type=template&id=7a1340fa&"
var renderjs
import script from "./painter.vue?vue&type=script&lang=js&"
export * from "./painter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

export default component.exports